export const transactionFilterParams = (filters, page, limit) => {
  const params = { page, limit };
  if (filters.type) params.type = filters.type;
  if (filters.category) params.categoryId = filters.category;
  if (filters.incomeSource) params.incomeSourceId = filters.incomeSource;
  if (filters.location) params.locationId = filters.location;
  if (filters.dateFrom) params.startDate = filters.dateFrom;
  if (filters.dateTo) params.endDate = filters.dateTo;
  return params;
};
